import { schema } from 'normalizr';

export const taskTypeSchema = new schema.Entity('taskTypes', {}, { idAttribute: 'TaskTypeId' });
export const taskTypeListSchema = [taskTypeSchema];
